module.exports = __webpack_public_path__ + "static/media/AvenirNext-Medium.a937ed58.woff2";